import {AxiosResponse} from "axios";
import {ToastContent} from "components";
import {toast} from "react-toastify";

/**
 * Says that an import was refused instead of letting it vanish.
 *
 * The API answers 503 when it could not queue the import: every url is then recorded as failed
 * ("could not be queued") and the task as Error, so nothing will arrive later. The request helpers
 * return the error response rather than throwing, so without this the click did nothing visible.
 *
 * @param response - The non-201 response of the create request (may be undefined on a network error).
 */
export const fireImportNotStartedToaster = (response?: AxiosResponse) => {
	// A 401 is the auth handling's to deal with (refresh or log out), not an import failure.
	if (response?.status === 401) {
		return;
	}

	const detail = response?.data?.detail;

	toast.error(ToastContent, {
		// One toast however often the button is clicked: a fixed id replaces rather than stacks.
		toastId: "bulk_import_not_started_toaster",
		autoClose: false,
		closeOnClick: true,
		data: {
			title:
				typeof detail === "string" && detail
					? detail
					: "The import could not be started. Please try again.",
		},
	});
};
